import React, { useState, useEffect } from 'react';
import service from 'axios';
import { siteApi } from '../Utils';
import { useTranslation } from 'react-i18next';

const stars = [1, 2, 3, 4, 5];

function formatToDMY(isoString) {
    const date = new Date(isoString);
    if (isNaN(date)) return '';

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${dd}.${mm}.${yyyy}`;
}

export default function Questionnaire({ companyInfo, updated, visible }) {
    const { t } = useTranslation("translation", { keyPrefix: "questionnaire" });

    const [isOpen, setIsOpen] = useState(false);
    const [rating1, setRating1] = useState(0);
    const [rating2, setRating2] = useState(0);
    const [rating3, setRating3] = useState(0);
    const [rating4, setRating4] = useState(0);
    const [rating5, setRating5] = useState(0);
    const [feedback, setFeedback] = useState('');
    const [company, setCompany] = useState(companyInfo);
    const [updatedDate, setUpdatedDate] = useState("");

    useEffect(() => {
        setCompany(companyInfo);
        setUpdatedDate(formatToDMY(updated));
    }, [companyInfo]);

    useEffect(() => {
        setRating1(0);
        setRating2(0);
        setRating3(0);
        setRating4(0);
        setRating5(0);
        setFeedback('');
    }, [isOpen]);

    const handleSubmit = () => {
        const ratings = [rating1, rating2, rating3, rating4, rating5];
        const req = ratings.map((puan, index) => ({
            SoruNo: index + 1,
            FirmaId: company.Id,
            Puan: puan
        }));

        service.post(siteApi + "webmusteri/anketkaydet", req, null)
            .then((res) => {
                if (res.data.Success) {
                    alert("Anketimize katıldığınız için teşekkür ederiz");
                }
                else {
                    alert("Teknik bir hata oluştu, hata ayrıntısı. Lütfen daha sonra tekrar deneyiniz.");
                }
            });
        setIsOpen(false);
    };


    const surveys = [
        { key: 'AnketSoru1', rating: rating1, setter: setRating1 },
        { key: 'AnketSoru2', rating: rating2, setter: setRating2 },
        { key: 'AnketSoru3', rating: rating3, setter: setRating3 },
        { key: 'AnketSoru4', rating: rating4, setter: setRating4 },
        { key: 'AnketSoru5', rating: rating5, setter: setRating5 },
    ];
    return (
        <div className="questionnaire-container">
            <section className="questionnaire_price-update">
                <div className="price-update__text">
                    <p className="questionnaire_price-update__line">
                        {t("priceUpdate.updated", { date: updatedDate })}
                    </p>
                    <p className="questionnaire_price-update__line">
                        {t("priceUpdate.vatIncluded")}
                    </p>
                </div>
                <button
                    className="questionnaire_evaluate-button"
                    onClick={() => setIsOpen(true)}
                    style={{ display: visible ? 'block' : 'none'}}
                >
                    {t("actions.evaluate")}
                </button>
            </section>

            {isOpen && (
                <div
                    className="questionnaire_modal-overlay"
                    onClick={() => setIsOpen(false)}
                >
                    <div
                        className="questionnaire_modal-content"
                        onClick={e => e.stopPropagation()}
                    >
                        {company && (
                            <div className="questionnaire_questionnaire">
                                {surveys.map(({ key, rating, setter }) => {
                                    const text = company[key];
                                    if (!text || !text.trim()) return null;

                                    return (
                                        <div className="questionnaire_question-block" key={key}>
                                            <h3>{text}</h3>
                                            <div className="questionnaire_star-rating">
                                                {stars.map(n => (
                                                    <span
                                                        key={`${key}-${n}`}
                                                        className={n <= rating ? 'questionnaire_star filled' : 'questionnaire_star'}
                                                        onClick={() => setter(n)}
                                                    >
                                                        ★
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        <h3>{t("explanation")}</h3>
                        <textarea
                            value={feedback}
                            onChange={e => setFeedback(e.target.value)}
                            placeholder={t("writeYourComments")}
                        />

                        <button
                            className="questionnaire_submit-button"
                            onClick={handleSubmit}
                        >
                            {t("actions.send")}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
